import React from 'react';
import Label from "components/general/Label"
import { findArray, filterArray } from 'helpers/utils'
import { ResultRank } from 'components/presentation/ResultRank'
import SportCode from "components/common/SportCode"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/* Current first athlete*/
function getCurrent(props) {
    return (
        props.currentSplit === '999' ? props.finalSplit : props.currentSplit
    )
}

/* Current by  athlete*/
function getCurrentAth(props) {
    const intermediates = filterArray(props, { er_code: ['INTERMEDIATE'] })
    const current = findArray(props, { er_code: ['CURRENT'] })?.er_value
    //let last = intermediates.filter(item => item?.extensions).map(it => it.extensions.ere_code ==='LAST' ? it : '')[0]?.er_pos
    const lastArr = intermediates && intermediates.length > 0 && intermediates?.filter(item => item?.extensions)
    let last;

    if (Array.isArray(lastArr)) {
        lastArr.forEach(function (item, index) {
            item.extensions?.forEach(function (it, index) {
                if (it.ere_code === 'LAST' && it.ere_value === 'Y') {
                    last = item.er_pos;
                }
            });
        });
    }

    const max = intermediates && intermediates.length > 0 && intermediates?.reduce((prev, current) => (Number(prev?.er_pos) > Number(current?.er_pos)) ? prev : current)


    return (
        current !== undefined ? current
            : last !== undefined ? last : max?.er_pos
    )
}


export function ColumnIntermediateRank({
    disableSort = false,
    className = 'text-end w-5',
    headerClassName = 'text-end w-5',
    label = 'HeaderRank',
    hasIrm = true,
    config = '',
    type = 'extendedResults'
}) {

    return (
        {
            Header: <Label data={label} />,
            accessor: (row) => {
                let node;
                switch (type) {
                    case 'extendedResults':
                        node = row?.extendedResults
                        break;
                    case 'resultAnalysis':
                        node = row?.resultAnalysis?.extendedResults
                        break;
                    default:
                        break;
                }
                let rowExtendedResult
                if (config) {
                    let position = config.currentPosition === config.finalPosition ? 'F' : config.currentPosition
                    rowExtendedResult = findArray(node, { er_code: ['INTERMEDIATE'], er_pos: [position.toString()] })
                } else {
                    rowExtendedResult = findArray(node, { er_code: ['INTERMEDIATE'], er_pos: [row.currentSplit] })
                }

                let intermediateRank = rowExtendedResult?.er_rank


                let valSortOrderSplit = rowExtendedResult?.er_sortorder ? rowExtendedResult?.er_sortorder : Number(row.sortOrder) + 500

                //Added for cases with photo that have no intermediate rank or rank
                let isPhoto = findArray(row?.extendedResults, { er_code: ['PHOTO'] })?.er_value
                if(isPhoto) return Number(row.sortOrder)

                return ( 
                    isNaN(rowExtendedResult?.er_rank) ?  Number(row.sortOrder) + 1000 : rowExtendedResult?.er_rank
                    //row.resultType !== 'IRM' ? valSortOrderSplit : Number(row.sortOrder) + 1000
                )


            },
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'RankIntermediate',
            Cell: (props) => {
                let row = props.cell.row.original
                let node;
                switch (type) {
                    case 'extendedResults':
                        node = row?.extendedResults
                        break;
                    case 'resultAnalysis':
                        node = row?.resultAnalysis?.extendedResults
                        break;
                    default:
                        break;
                }
                let rowExtendedResult
                let position
                let intermediateRank

                if (config) {
                    position = config.currentPosition === config.finalPosition ? 'F' : config.currentPosition
                    rowExtendedResult = findArray(node, { er_code: ['INTERMEDIATE'], er_pos: [position.toString()] })
                    intermediateRank = rowExtendedResult?.er_rank
                } else {
                    rowExtendedResult = findArray(node, { er_code: ['INTERMEDIATE'], er_pos: [row.currentSplit] })
                    intermediateRank = rowExtendedResult?.er_rank
                }

                let rowNumberIrm = findArray(node, { er_code: ['IRM_LAP'] })
                let numberIrm = rowNumberIrm?.er_value
                let resultIrm = (row?.resultIrm)

                let valInter = (resultIrm === 'DNF' && numberIrm !== undefined)
                    ? resultIrm + numberIrm
                    : resultIrm

                let isPhoto = findArray(row?.extendedResults, { er_code: ['PHOTO'] })?.er_value
                if (isPhoto) return <FontAwesomeIcon className="font-icon" icon={faCamera} />

                return (
                    (row.resultType !== 'IRM' && resultIrm !== 'OTL')
                        ? (resultIrm === 'LAP' && numberIrm !== undefined)
                            ? "-" + numberIrm + resultIrm
                            : intermediateRank

                        : hasIrm ? valInter : ''
                )
            }


        }
    )
}

export function ColumnIntermediateSortOrderTest({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderSortOrder',
    hasIrm = true,
    config = '',
    type = 'extendedResults'
}) {

    return (
        {
            Header: <Label data={label} />,
            accessor: (row) => {
                let node;
                switch (type) {
                    case 'extendedResults':
                        node = row?.extendedResults
                        break;
                    case 'resultAnalysis':
                        node = row?.resultAnalysis?.extendedResults
                        break;
                    default:
                        break;
                }
                let rowExtendedResult
                if (config) {
                    let position = config.currentPosition === config.finalPosition ? 'F' : config.currentPosition
                    rowExtendedResult = findArray(node, { er_code: ['INTERMEDIATE'], er_pos: [position.toString()] })
                } else {
                    rowExtendedResult = findArray(node, { er_code: ['INTERMEDIATE'], er_pos: [row.currentSplit] })
                }
                let valSortOrderSplit = rowExtendedResult?.er_sortorder ? rowExtendedResult?.er_sortorder : Number(row.sortOrder) + 500
                return (
                    row.resultType !== 'IRM' ? valSortOrderSplit : Number(row.sortOrder) + 1000
                )


            },
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'RankIntermediateTest'

        }



    )
}
//Ver si es generico o cambia el ei_code -  Usado en CRD en el evento time trial
export function ColumnRankOfIntermediate({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderRank',
    dataAdditional,
    onlyRank = false,
}) {

    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => (
                props?.extendedResults
                    ? findArray(props.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [getCurrent(props)] })?.er_sortorder
                    : ''
            ),
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'RankOfIntermediate',

            Cell: (props) => {
                let currentSplitAthlete = getCurrentAth(props.cell.row.original.extendedResults);
                let rank = findArray(props.cell.row.original.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [currentSplitAthlete] })?.er_rank
                rank = (rank !== undefined) ? rank : ''
                let numAthletesIntermediatePoint = findArray(dataAdditional, { ei_code: ['AFTER_INT'], ei_pos: [currentSplitAthlete] })?.ei_value
                numAthletesIntermediatePoint = (numAthletesIntermediatePoint !== undefined) ? numAthletesIntermediatePoint : ''

                let symbol = rank !== '' || numAthletesIntermediatePoint !== '' ? '/' : ''

                return (
                    (props.cell.row.original.resultType !== 'IRM')
                        ? onlyRank ? rank : rank + symbol + numAthletesIntermediatePoint
                        : ''
                )
            },

        }
    )
}


export function ColumnIntermediateDistance({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderIntermediate',
    config = '',
    showLaps = false

}) {

    return (
        {
            Header: <Label data={label} />,
            //accessor: (props) => (findArray(config, { ei_code: ['INTERMEDIATE'], ei_pos: [getCurrentAth(props)] }).ei_value),
            //accessor: (props) => getCurrentAth(props),
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'ResultIntermediate',
            Cell: (props) => {
                const { mirs_discipline } = useUrlFriendlyToParameters()
                let item = findArray(config, { code: ['INTERMEDIATE'], pos: [getCurrentAth(props.cell.row.original.extendedResults)] })
                let distance = item?.value ? item?.value : <Label data="LabelStarted" />

                let type = findArray(item?.extension, { code: ['TYPE'] })?.value
                let res = (type !== undefined)
                    ? <> <SportCode code={type} discipline={mirs_discipline} entity="@IntPtType" /> - </>
                    : ''

                let header = item.pos === 'F' ? <Label data="HeaderFinish" /> : <> {res}{distance}<Label data='LabelKm' /> </>

                return (
                    (props.cell.row.original.resultType !== 'IRM')
                        ? isNaN(Number(distance))
                            ? distance
                            : header
                        : ''
                )
            },


        }
    )
}

export function ColumnIntermediateTime({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTime',
}) {

    return (
        {
            Header: <Label data={label} />,
            //accessor: (props) => (findArray(config, { ei_code: ['INTERMEDIATE'], ei_pos: [getCurrentAth(props)] }).ei_value),
            // accessor: (props) => getCurrentAth(props),
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'IntermediateTime',
            Cell: (props) => {
                let row = props.cell.row.original
                let rowExtendedResult = findArray(row.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [getCurrentAth(row.extendedResults)] })
                let intermediateTime = rowExtendedResult?.er_value
                let intermediateRank = rowExtendedResult?.er_rank
                intermediateRank = row.currentSplit === rowExtendedResult?.er_pos
                    ? ""
                    : intermediateRank

                //props.cell.row.original.resultIrm !== 'LAP'
                let rowNumberIrm = findArray(row.extendedResults, { er_code: ['IRM_LAP'] })
                let numberIrm = rowNumberIrm?.er_value

                let resultIrm = (props.cell.row.original.resultIrm)
                let valInter = (resultIrm === 'DNF' && numberIrm !== undefined)
                    ? resultIrm + numberIrm
                    : resultIrm
                let cell = <ResultRank result={intermediateTime} rank={intermediateRank} />
                return (
                    (props.cell.row.original.resultType !== 'IRM')
                        ? cell
                        : valInter
                )

            },


        }
    )
}

export function ColumnIntermediateDiff({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTimeBehind',
    config = ''
}) {

    return (
        {
            Header: <Label data={label} />,
            //accessor: (props) => (findArray(config, { ei_code: ['INTERMEDIATE'], ei_pos: [getCurrentAth(props)] }).ei_value),
            //accessor: (props) => getCurrentAth(props),
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'IntermediateDiff',
            Cell: (props) => {
                let row = props.cell.row.original
                let val = findArray(row.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [getCurrentAth(row.extendedResults)] })?.er_diff
                return (
                    (row.resultType !== 'IRM' && row.resultIrm !== 'REL' && row.resultIrm !== 'OTL')
                        ? val
                        : row.resultIrm === 'REL' || row.resultIrm === 'OTL'
                            ? row.resultIrm
                            : ''
                )

            },


        }
    )
}


export function ColumnIntermediateAvgSpeed({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderAvgSpeed',
    config = ''
}) {

    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => (
                props?.extendedResults
                    ? findArray(props.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [getCurrentAth(props.extendedResults)] }).er_sortorder
                    : ''
            ),
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'AvgSpeedIntermediate',
            Cell: (props) => {
                let val = findArray(props.cell.row.original.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [getCurrentAth(props.cell.row.original.extendedResults)] })?.er_speed
                return (
                    (props.cell.row.original.resultType !== 'IRM')
                        ? val
                        : ''
                )

            },


        }
    )
}
